/* TI slider drag v3 (27 Oct 2026). Lets a mouse click-hold-and-drag the product-page "You May Also Like" rows left and right.
   Touch swipe is left to the browser. Plain clicks (Add To Cart, card links) keep working: a click is only swallowed when the mouse actually dragged.
   v3: one scroll update per screen frame (no pile-up of work), the browser is told the row is moving only while it moves, and the glide to the nearest card is a short eased animation. */
(function () {
  if (window.__tiSliderDrag) return;
  window.__tiSliderDrag = true;
  var SEL = '[id*="featured_collection"] ul.slider';
  var suppress = false;
  var active = null; // {s, raf, settleRaf}

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function release(s) {
    s.classList.remove('ti-dragging');
    s.style.removeProperty('scroll-snap-type');
    s.style.removeProperty('scroll-behavior');
    s.style.removeProperty('will-change');
  }

  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.closest && e.target.closest(SEL)) e.preventDefault();
  });

  window.addEventListener('click', function (e) {
    if (suppress) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
  }, true);

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var s = e.target && e.target.closest && e.target.closest(SEL);
    if (!s || s.scrollWidth <= s.clientWidth + 2) return;

    // grabbing the row while it is still gliding: stop the glide and take over
    if (active && active.settleRaf) { cancelAnimationFrame(active.settleRaf); release(active.s); }
    active = null;

    var x0 = e.clientX, left0 = s.scrollLeft, moved = false, lastX = x0, lastT = performance.now(), v = 0;
    var wantLeft = left0, frame = 0;
    var state = { s: s, settleRaf: 0 };

    function apply() { frame = 0; s.scrollLeft = wantLeft; }

    function move(ev) {
      var dx = ev.clientX - x0;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        s.classList.add('ti-dragging');
        s.style.setProperty('scroll-snap-type', 'none', 'important');
        s.style.setProperty('scroll-behavior', 'auto', 'important');
        s.style.setProperty('will-change', 'scroll-position', 'important');
      }
      if (!moved) return;
      wantLeft = left0 - dx;
      if (!frame) frame = requestAnimationFrame(apply);
      var t = performance.now();
      v = 0.8 * v + 0.2 * ((ev.clientX - lastX) / Math.max(1, t - lastT));
      lastX = ev.clientX; lastT = t;
      ev.preventDefault();
    }

    function settle(to) {
      var from = s.scrollLeft, t0 = performance.now();
      var dur = reduced() ? 1 : Math.min(360, 160 + Math.abs(to - from) * 0.22);
      function step(now) {
        var p = Math.min(1, (now - t0) / dur);
        var k = 1 - Math.pow(1 - p, 3);
        s.scrollLeft = from + (to - from) * k;
        if (p < 1) { state.settleRaf = requestAnimationFrame(step); }
        else { state.settleRaf = 0; release(s); active = null; }
      }
      state.settleRaf = requestAnimationFrame(step);
    }

    function up() {
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', up);
      document.removeEventListener('pointercancel', up);
      window.removeEventListener('blur', up);
      if (frame) { cancelAnimationFrame(frame); apply(); }
      if (!moved) return;
      suppress = true;
      setTimeout(function () { suppress = false; }, 80);
      var sRect = s.getBoundingClientRect();
      var sp = parseFloat(getComputedStyle(s).scrollPaddingLeft) || 0;
      var target = s.scrollLeft - v * 240;
      var best = null, bd = 1e9;
      [].slice.call(s.children).forEach(function (li) {
        var pos = li.getBoundingClientRect().left - sRect.left + s.scrollLeft - sp;
        var d = Math.abs(pos - target);
        if (d < bd) { bd = d; best = pos; }
      });
      if (best === null) best = s.scrollLeft;
      best = Math.max(0, Math.min(best, s.scrollWidth - s.clientWidth));
      active = state;
      settle(best);
    }

    document.addEventListener('pointermove', move, { passive: false });
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
    window.addEventListener('blur', up);
  });
})();
